import { Button, DatePicker, Form, Input, Select, Typography } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { useLanguage } from '../../../../../hooks/useLanguage';
export default ({onSearchCallback, initValue}) => {
    const [state, setState]=useState(initValue);
    const [,getLang] = useLanguage();
    return (
        <div style={{padding:12, background:'#ffffff88', display:'flex', flexDirection:'column', overflow:'auto'}}>
            <Typography.Text strong>{getLang('search')}</Typography.Text>
                <Form 
                    layout='vertical'
                    initialValues={state}
                    onFinish={onSearchCallback}
                    autoComplete="off"
                    
                >
                    <Form.Item
                        label={getLang("telex_date")}
                        name="telex_date"
                        style={{marginBottom:4}}
                        rules={[{
                            validator:async(rule, value)=>{
                                // console.log({rule, value})
                                const [from, to]=value;
                                const diff=moment.duration(to.diff(from)).days();
                                if(diff>7){
                                    throw new Error('Cannot more than 7 days');
                                }
                                return true;
                            }
                        }]}
                    >
                        <DatePicker.RangePicker 
                            showTime={true}
                            value={state.telex_date}
                            format={'DD-MMM-YYYY'}
                            onChange={(val, strVal)=>{
                                setState({...state, telex_date:val});
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{marginBottom:4}}
                        label={getLang('origin')}
                        name="Origin"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={getLang('dest')}
                        style={{marginBottom:4}}
                        name="destination"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={{marginBottom:4}}
                        label={getLang('smi')}
                        name="subSmi"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={{marginBottom:4}}
                        label={getLang('flight_number')}
                        name="message"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={{marginBottom:4}}
                        label={getLang('status')}
                        name="status"
                    >
                        <Select>
                            <Select.Option value={10}>ALL</Select.Option>
                            <Select.Option value={0}>Pending</Select.Option>
                            <Select.Option value={1}>Success</Select.Option>
                            <Select.Option value={2}>Error</Select.Option>
                            <Select.Option value={3}>Ignored</Select.Option>
                        </Select>
                    </Form.Item>
                    <Button block type='primary' htmlType='submit'>Search</Button>
                </Form>
        </div>    
    )
}